import { getPrivacyPolicyLink, NavigationLink } from "common/NavigationLinks"
import NextLink from "common/NextLink"
import nextLinks from "next.links"
import { memo, useEffect, useState } from "react"
import Shared from "theme/shared"
import Styled from "./FooterStyled"

type FooterNavLinkProps = { section: NavigationLink }

const FooterNavLink = ({ section }: FooterNavLinkProps) => {
  const [updatedSection, setupdatedSection] = useState<NavigationLink>()
  useEffect(() => {
    if (
      (Array.isArray(section?.link) &&
        section?.link?.some((s) => s.title === "הצהרת פרטיות")) ||
      section?.link === nextLinks.privacyPolicy
    ) {
      getPrivacyPolicyLink()
        .then((link) => {
          if (section) {
            const updatedSection = Array.isArray(section?.link)
              ? section?.link?.map((section) => {
                  if (section.title === "הצהרת פרטיות") {
                    return { ...section, link: link || "", blank: true }
                  }
                  return section
                })
              : section?.link === nextLinks.privacyPolicy
                ? link || ""
                : section?.link
            setupdatedSection({ title: section.title, link: updatedSection })
          }
        })
        .catch((error) => {
          console.error("Error fetching privacy policy link:", error)
          setupdatedSection(section)
        })
    } else {
      setupdatedSection(section)
    }
  }, [section])

  if (!Array.isArray(updatedSection?.link)) return null
  return (
    <>
      <Shared.Desktop>
        <Styled.Title>{updatedSection?.title}</Styled.Title>
      </Shared.Desktop>
      {updatedSection?.link.map((item, index) => (
        <NextLink key={index} href={item.link} passHref>
          <Styled.Link
            href={item.link}
            target={item.blank ? "_blank" : "_self"}
          >
            {item.title}
          </Styled.Link>
        </NextLink>
      ))}
    </>
  )
}

export default memo(FooterNavLink)
